import React from 'react';
import { useSite } from '../../context/SiteContext';
import { MessageCircle, Send, Instagram, Youtube } from 'lucide-react';
import { resolveMediaUrl } from '../admin/MediaUpload';

function WAIcon() {
  return (
    <svg viewBox="0 0 32 32" className="w-4 h-4 fill-current">
      <path d="M19.11 17.205c-.372 0-.892 1.044-1.353.974-.428-.075-.901-.27-1.327-.555-1.13-.747-1.916-1.477-2.6-2.6-.285-.426-.48-.9-.554-1.327-.07-.46.974-.981.974-1.353 0-.371-.974-1.59-1.299-1.946-.279-.305-.587-.34-.722-.341-.186 0-.4-.046-.611-.046-.211 0-.55.082-.835.387-.286.305-1.092 1.066-1.092 2.604 0 1.537 1.118 3.022 1.273 3.23.155.21 2.198 3.357 5.327 4.706.745.32 1.327.512 1.781.656.748.237 1.43.204 1.969.124.6-.09 1.846-.755 2.107-1.486.26-.73.26-1.358.182-1.486-.077-.128-.286-.205-.6-.36-.313-.155-1.847-.91-2.133-1.014-.286-.103-.494-.155-.703.155-.21.31-.808 1.014-.99 1.224-.181.21-.363.236-.677.082zM16 4C9.373 4 4 9.373 4 16c0 2.244.611 4.345 1.676 6.149L4 28l5.998-1.654A11.94 11.94 0 0016 28c6.627 0 12-5.373 12-12S22.627 4 16 4z" />
    </svg>
  );
}

const icons = {
  whatsapp: <WAIcon />,
  telegram: <Send size={14} />,
  instagram: <Instagram size={14} />,
  youtube: <Youtube size={14} />
};

export default function Footer() {
  const { data } = useSite();
  const f = data.footer || {};
  const s = data.social || {};
  const colors = {
    whatsapp: 'bg-[#25d366] text-white',
    telegram: 'bg-[#229ed9] text-white',
    instagram: 'bg-gradient-to-br from-[#f58529] via-[#dd2a7b] to-[#8134af] text-white',
    youtube: 'bg-[#ff0000] text-white'
  };
  return (
    <footer className="mt-10 border-t border-zinc-900 bg-zinc-950">
      <div className="max-w-[1400px] mx-auto px-4 py-8 grid grid-cols-1 md:grid-cols-4 gap-6">
        <div>
          {resolveMediaUrl(data.branding?.logoImage || data.branding?.logo || f?.logo) ? (
            <div className="mb-3 flex items-center">
              <img
                src={resolveMediaUrl(data.branding?.logoImage || data.branding?.logo || f?.logo)}
                alt={data.branding?.logoText || 'Brand Logo'}
                className="max-h-12 max-w-[200px] object-contain"
              />
            </div>
          ) : (
            <div className="flex items-baseline gap-1 mb-3">
              <span className="font-display text-2xl font-extrabold tracking-[0.12em] text-[color:var(--gold)]">{data.branding?.logoText || 'GAMEX'}</span>
              <span className="font-display text-[10px] font-bold text-zinc-400">{data.branding?.logoAccent || 'HUB'}</span>
            </div>
          )}
          <h4 className="text-zinc-100 font-bold text-sm mb-2">{f.aboutTitle}</h4>
          <p className="text-zinc-400 text-xs leading-relaxed mb-4">{f.aboutText}</p>
        </div>
        {(f.columns || []).length > 0 && (
          <div className="md:col-span-3 grid grid-cols-3 gap-3 md:gap-6">
            {(f.columns || []).map((c) => (
              <div key={c.title}>
                <h4 className="text-zinc-100 font-bold text-sm mb-3">{c.title}</h4>
                <ul className="space-y-1.5">
                  {c.items.map((it) => (
                    <li key={it}><a href="#" className="text-zinc-400 hover:text-[color:var(--gold)] text-xs">{it}</a></li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="border-t border-zinc-900">
        <div className="max-w-[1400px] mx-auto px-4 py-4">
          <p className="text-zinc-500 text-xs text-center">{f.copyright}</p>
        </div>
      </div>
    </footer>
  );
}
